module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm7.304 15.8l.703 2.4-13.656 4-.702-2.4zM8 10c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2zm12 0c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2z\"/></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./icons/wondering.svg
 ** module id = 19
 ** module chunks = 0
 **/